/**
 * 订单管理 交易订单
 */
<template>
   <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>项目进度表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
       <el-select-tree :options="treeData" :value="value" @getValue="getSelectedValue"></el-select-tree>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData.slice((currentPage - 1) * pageSize, currentPage * pageSize)" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" type="index" width="60">
      </el-table-column>
      <el-table-column  prop="OName" label="模块" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column  prop="FNumber" label="材料代码" width="200" show-overflow-tooltip>
      </el-table-column>
      <el-table-column  prop="FMName" label="材料名称" width="140" show-overflow-tooltip>
      </el-table-column>
      <el-table-column  prop="FMmodel" label="材料规格" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column  prop="FCQty" label="采购数量" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column  prop="FEndQty" label="库存数量" width="180" show-overflow-tooltip>
      </el-table-column>
      <el-table-column  prop="FSQty" label="采购申请数量" width="150" show-overflow-tooltip>
      </el-table-column>
      <el-table-column  prop="FQty" label="采购订单数量" width="150" show-overflow-tooltip>
      </el-table-column>
       <el-table-column  prop="FStockQty" label="采购入库数量" width="150" show-overflow-tooltip>
      </el-table-column>
        <el-table-column label="领料数量" width="140" prop="FBQty">
				</el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <div class="block">
							<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
								:current-page="currentPage" :page-sizes="[10,20,30,40]" :page-size="pageSize"
								layout="total, sizes, prev, pager, next, jumper" :total="listData.length">
							</el-pagination>
						</div>
  </div>
</template>

<script>
import {
		deptList,
		deptSave,
		deptDelete,
		login,
		GetLB,
		accountset,
		LinkQueryApp,
		LinkUpNextApp,
		OperateBill
	} from '../../api/userMG';

import axios from 'axios';
import FileSaver from 'file-saver'
import XLSX from 'xlsx'
import Pagination from   '../../components/Pagination'
import elSelectTree from '../../components/el-select-tree.vue'
export default {
  data() {
    return {
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '预览',
      treeData:[],
      payType: [
        
      ],
      payway: [
      ],
      currentPage:1,
      pageSize:20,
      eForm:'',
      editForm: {
        id: '',
        name: '',
        payType: 1,
        partner: '',
        subMchId: '',
        appid: '',
        notifyUrl: '',
        signType: '',
        partnerKey: '',
        sellerUserId: '',
        certPath: '',
        certPassword: '',
        rsaKey: '',
        token: localStorage.getItem('logintoken')
      },
      formInline: {
        page: 1,
        limit: 10,
        machineNo: '',
        orderNo: '',
        transId: '',
        payType: 0,
        orderStatus: 0,
        token: localStorage.getItem('logintoken')
      },
      v_str_AccountID:154,
      value:'',
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination,
    elSelectTree
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata()
  },
methods: {
  /**
   * 里面的方法只有被调用才会执行
   */
   handleSizeChange(val) {
        this.pageSize = val;
        this.getSelectedValue(this.eForm);
			},
			handleCurrentChange(val) {
        this.currentPage = val;
        this.getSelectedValue(this.eForm);
			},
  getdata(){
				let arr;
				let phems = {
					'v_str_AccountID': this.v_str_AccountID,
					'jsSQL': "{\"SQL\":[{\"select\":\"  select * from  t_Item  where FItemClassID='3005'\"}]}"
				}
				login(phems).then(data => {
						 arr = data.Data.Table
				console.log(arr)
				let att=this.convert(arr)
				this.treeData=att
				})
      },
      convert(list) {
			    let res = []
			    let maps = list.reduce((pre, cur) => { pre[cur.FItemID] = cur; return pre }, {}) 
			    // let maps = new Map(Array.from(list, (x) => [x.id, x])) 
			    for(let i = 0, len = list.length; i < len; i++ ) {
			        let item = list[i]
					item['label']=item['FName']
					item['name']=item['FName']
					item['id']=item['FItemID']
			        if(item.FParentID === 0) {
			            res.push(item)
			        } else {
			        let parent = maps[item.FParentID]
			        // let parent = maps.get(item.parentId)
			  	//	console.log(parent)
			        if (parent) {
			          (parent.children || (parent.children = [])).push(item);
			        }
			      }
			    }
			 return res
      },
      getSelectedValue(value) {
            console.log(value)
            this.eForm=value
			let phems = {
				v_str_AccountID: this.v_str_AccountID,
				jsSQL: "{\"SQL\":[{\"select\":\"select * from AYPorderlist where ID  ='"+value.id+"'  order by ID,OName \"}]}"
				}
				login(phems).then(data => {
				   let arr= data.Data.Table
           
 
           this.payway=arr;
           this.listData=arr;

      

				})
			},
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      this.editForm = row
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          ConfigSave(this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.success) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              //this.$message.error('支付配置信息保存失败，请稍后再试！')
            })
        } else {
          return false
        }
      })
    },
    // 删除公司
    deleteUser(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          ConfigDelete(row.deptId)
            .then(res => {
              if (res.success) {
                this.$message({
                  type: 'success',
                  message: '公司已删除!'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('支付配置信息删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      this.editFormVisible = false
      this.$refs[formName].resetFields()
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/pay/Order.vue